import { render, staticRenderFns } from "./OriginFilter.vue?vue&type=template&id=052981a6&"
import script from "./OriginFilter.vue?vue&type=script&lang=js&"
export * from "./OriginFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports